import React from "react";

import GuideYearWorld from "./component/GuideYearWorld";
import GuideYearContinent from "./component/GuideYearContinent";
import GuideYearCountry from "./component/GuideYearCountry";
import GuideYearType from "./component/GuideYearType";

const GuideFestyful = (props) => {
  const { slugs } = props;
  if (slugs.length === 1) {
    return <GuideYearWorld {...props} yearSelected={slugs[0]} />;
  } else if (slugs.length === 2) {
    return (
      <GuideYearContinent
        {...props}
        yearSelected={slugs[0]}
        continentSelected={slugs[1]}
      />
    );
  } else if (slugs.length === 3) {
    return (
      <GuideYearCountry
        {...props}
        yearSelected={slugs[0]}
        continentSelected={slugs[1]}
        countrySelected={slugs[2]}
      />
    );
  } else if (slugs.length === 4) {
    return (
      <GuideYearType
        {...props}
        yearSelected={slugs[0]}
        continentSelected={slugs[1]}
        countrySelected={slugs[2]}
        stateSelected={slugs[3]}
        citySelected={slugs[3]}
        typeSelected={slugs[3]}
      />
    );
  }
};

export default GuideFestyful;
